module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("1px 解决方案")]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('p', [_vm._v("1px 方案在 VUX 组件内应用广泛，包括 "), _c('code', [_vm._v("Grid")]), _vm._v(", "), _c('code', [_vm._v("ButtonTab")]), _vm._v(", "), _c('code', [_vm._v("XTable")]), _vm._v(", "), _c('code', [_vm._v("XButton")]), _vm._v(", "), _c('code', [_vm._v("Cell")]), _vm._v(" 等等。")]), _vm._v(" "), _c('p', [_vm._v("利用 "), _c('code', [_vm._v("Flexbox")]), _vm._v(" + "), _c('code', [_vm._v("1px")]), _vm._v(" 你可以实现复杂的宫格布局。")])]), _vm._v(" "), _c('h2', [_vm._v("引入")]), _vm._v(" "), _c('p', [_vm._v("在你项目的"), _c('code', [_vm._v("App.vue")]), _vm._v("引入，组件内不需要再重复引入。")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("style")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("lang")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"less\"")]), _vm._v(">")]), _c('span', {
    staticClass: "undefined"
  }, [_vm._v("\n@import '~vux/src/styles/1px.less';\n")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("style")]), _vm._v(">")]), _vm._v("\n")])]), _vm._v(" "), _c('h2', [_vm._v("可用类名：")]), _vm._v(" "), _c('ul', [_c('li', [_c('code', [_vm._v("vux-1px-l")]), _vm._v(" 左边框")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("vux-1px-r")]), _vm._v(" 右边框")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("vux-1px-t")]), _vm._v(" 上边框")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("vux-1px-b")]), _vm._v(" 下边框")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("vux-1px-tb")]), _vm._v(" 上下边框")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("vux-1px")]), _vm._v(" 全边框")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-09d27be0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-09d27be0"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/1px-150.vue
// module id = 2020
// module chunks = 480